import { get } from '../../helpers/api';

export const SERVICE_URI = '/stocks';
export const BASE_URI = '/api/v1/restrictions';
export const OFFERS_SERVICE_URI = '/offers';
export const METRO_BASE_URI = '/api/v1/metro';

export const getAxisWithAdminUnits = () =>
  get(`${SERVICE_URI}${BASE_URI}/axis`, {});

export const getAdminUnits = () =>
  get(`${OFFERS_SERVICE_URI}${METRO_BASE_URI}/administrative-units`, {});
